import { Refresh } from '@mui/icons-material';
import { Typography, Button } from '@mui/material';
import { useLazyGetApiLibraryTreeQuery } from '../../../app/athenaApiGen';
import { EmptyTreeContainer } from '../StyledComponents';

const EmptyTree = () => {
  const [refetchTree] = useLazyGetApiLibraryTreeQuery();

  return (
    <EmptyTreeContainer>
      <Typography variant="h6" color="text.secondary">
        No Items Available
      </Typography>
      <Button
        variant="contained"
        startIcon={<Refresh />}
        onClick={() => refetchTree({ includeAll: true })}
      >
        Refresh
      </Button>
    </EmptyTreeContainer>
  );
};

export default EmptyTree;
